export default {
  specs: 'data-comp-specs',
  container: 'data-comp-specs-container',
  state: 'data-comp-specs-state',
  trigger: 'data-comp-specs-trigger',
};
